import { generateEnumTranslations } from "@app/shared/enumTranslate/generateEnumTranslations";

export enum DeviceType {
  ScreenOnly = 1,
  SensorOnly = 2,
  ScreenWithSensor = 3
}

export const DeviceTypeTranslations = generateEnumTranslations(DeviceType, 'screens.deviceTypes');